<template>
  <div class="c-entrepreneur-title-text-copy">
    <ul class="c-entrepreneur-title-text-copy__inner">
      <li class="c-entrepreneur-title-text-copy__inner__title">
        <!-- <h3 class="t-t3-heavy | u-c-dark">{{ data.title }}</h3> -->
        <prismic-rich-text v-if="data.title_right_column" :field="data.title_right_column" />
      </li>
      <li class="c-entrepreneur-title-text-copy__inner__copy">
        <prismic-rich-text v-if="data.copy_right_column" :field="data.copy_right_column" />
      </li>
    </ul>
  </div>
</template>

<script>
import PrismicRichText from "objects/PrismicRichText";
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    PrismicRichText
  }
};
</script>

<style lang="scss">
.c-entrepreneur-title-text-copy {
  padding: var(--grid-gutter) 0px;
  @media #{$breakpoint-horizontal} {
    max-width: 500px;
    margin-left: var(--grid-gutter-triple);
    padding: var(--grid-gutter-half);
  }
  &__inner {
    @include reset-list;
    display: flex;
    flex-direction: column;

    &__title {
      padding-bottom: var(--grid-gutter-half);
      @include t3-light;
    }
    &__copy {
      strong {
        font-family: "Sharp Grotesk", "Helvetica Neue", Arial, sans-serif;
        font-weight: 400;
      }
    }
  }
}
</style>
